/**
 * English translations
 */

import type { TranslationDict } from "../types";

export const en: TranslationDict = {
  // Model related
  model: {
    image: {
      "Seedream 4.0": {
        label: "Seedream 4.0",
        description: "Integrated generation & editing in one",
      },
      "Seedream 4.5": {
        label: "Seedream 4.5",
        description: "Latest image generation & editing in one",
      },
      "Midjourney V7": {
        label: "Midjourney V7",
        description: "Ideal for artistic, conceptual images",
      },
      "Nano Banana": {
        label: "Nano Banana",
        description: "Fast, consistent image editing",
      },
      "Nano Banana Pro": {
        label: "Nano Banana Pro",
        description: "New SOTA image generation & editing model",
      },
      "Flux.2": {
        label: "Flux.2",
        description: "Superior text & composition",
      },
      "Flux.2-Pro": {
        label: "Flux.2-Pro",
        description: "Advanced text & composition",
      },
      "GPT Image 1.5": {
        label: "GPT Image 1.5",
        description: "Elite prompt following & logic",
      },
    },
    video: {
      "Seedance 1.0 Pro": {
        label: "Seedance 1.0 Pro",
        description: "Smooth multi-scene storytelling",
      },
      "Seedance 1.0 Pro Fast": {
        label: "Seedance 1.0 Pro Fast",
        description: "Efficient, low-cost 1080P video",
      },
      "Kling V2.6 Pro": {
        label: "Kling V2.6 Pro",
        description: "Dynamic motion and camera effects",
      },
      "Kling O1": {
        label: "Kling O1",
        description: "Unified multimodal video model",
      },
      "Kling V3.0": {
        label: "Kling V3.0",
        description: "All in one flagship video model",
      },
      "Veo 3 Fast": {
        label: "Veo 3 Fast",
        description: "Speed-optimized version of Veo 3",
      },
      "Veo 3": {
        label: "Veo 3",
        description: "High-fidelity video + native audio",
      },
      "Veo 3.1": {
        label: "Veo 3.1",
        description: "Latest SOTA video model from Google",
      },
      "Sora 2 Pro": {
        label: "Sora 2 Pro",
        description: "Latest SOTA video model from OpenAI",
      },
      "Hailuo 2.3 Standard": {
        label: "Hailuo 2.3 Standard",
        description: "Efficient, low-cost 768P video",
      },
      "Hailuo 2.3 Pro": {
        label: "Hailuo 2.3 Pro",
        description: "Higher fidelity 1080P video",
      },
      "Hailuo 2.3 Pro Fast": {
        label: "Hailuo 2.3 Pro Fast",
        description: "Fast version of Hailuo 2.3 Pro",
      },
      "Magi 1.1": {
        label: "Magi-1.1",
        description: "A stunning AI video generator & extender",
      },
      "Vidu Q2": {
        label: "Vidu Q2",
        description: "High-quality camera movements and motion dynamics",
      },
      "Wan V2.6": {
        label: "Wan V2.6",
        description: "Fast long-form narrative",
      },
      "Seedance V1.5 Pro": {
        label: "Seedance V1.5 Pro",
        description: "Fluid motion & physics",
      },
      // Avatar
      "Kling AI Avatar V2 Pro": {
        label: "Kling AI Avatar V2 Pro",
        description: "Latest realistic, expressive avatars",
      },
      "Gaga Avatar": {
        label: "Gaga Avatar",
        description: "Our cost-efficient avatar model",
      },
      "Omnihuman V1.5": {
        label: "Omnihuman V1.5",
        description: "Expressive full-body motion",
      },
    },
  },

  // Error messages
  error: {
    networkError: "Network error, please try again later",
    uploadFailed: "Upload failed",
    generateFailed: "Generation failed",
    unknownError: "Unknown error",
    threadIdNotFound: "Thread ID not found",
    modelIsRequired: "Please select a model",
    audioPlayFailed: "Failed to play audio sample",
    audioFileRequired: "Please select an audio file",
    fileSizeExceeded: "File size should not exceed 10MB",
    voiceUploadFailed: "Failed to upload voice",
    replaceFailed: "Replace failed",
    promptRequired: "Prompt is required",
    attachmentRequired: "Image attachment is required for this model",
    dialogueRequired: "Dialogue is required for avatar generation",
    voiceRequired: "Voice selection is required for avatar generation",
    // Model selection errors
    modelNotFound: "Model not found",
    imageRequired: "This model requires at least one image attachment",
    onlySingleImageSupported: "This model only supports single image input",
    imageNotSupported: "This model does not support image input",
    modelNotSupportMultiImages:
      "This model supports only one image as reference",
  },

  // Success messages
  success: {
    voiceUploaded: "Voice uploaded successfully",
  },

  messages: {
    continue: "Continue",
  },
};
